import { StyledBaseInput } from "@/Components/atoms/BaseComponents/BaseInput/style";
import { styled } from "@mui/material";

const StyledOffer = styled("div")`
  max-width: 330px;
  width: 100%;

  .make-offer {
    &__inner {
      width: 100%;
      background-color: ${(props) => props.theme.customTheme.colors.gray99};
      border: 1px solid ${(props) => props.theme.customTheme.colors.secondary};
      border-radius: 10px;
      /* margin-bottom: 16px; */
    }

    &__header {
      padding: 10px 0 10px;
      border-bottom: 1px solid
        ${(props) => props.theme.customTheme.colors.secondary};
    }

    &__header-title {
      font-size: ${(props) => props.theme.customTheme.sizes.middle};
      color: ${(props) => props.theme.customTheme.colors.dark100};
      font-weight: 600;
      line-height: 1.5;
      margin: 0;

      display: flex;
      gap: 4px;
      align-items: center;
      justify-content: center;
    }

    &__main {
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 8px;
      padding: 15px 28px;
    }

    &__main-title {
      margin: 0;
      font-size: ${(props) => props.theme.customTheme.sizes.normal};
      font-weight: 400;
    }
    &__main-price {
      margin: 0;
      font-size: ${(props) => props.theme.customTheme.sizes.xMiddle};
      font-weight: 500;

      label {
        display: flex;
        align-items: center;
        border-radius: 0.5rem;
        background: #fff;
        padding: 3px;
        border: 2px solid ${(props) => props.theme.customTheme.colors.primary};
        box-shadow: 0 0 1px 1px #fff, 0 0 1px 2px transparent;
        outline: none;
        transition: box-shadow 0.1s ease;
        border: 1px solid ${(props) => props.theme.customTheme.colors.secondary};
        font-family: "Inter", "Arial", sans-serif;

        &:focus {
          box-shadow: 0 0 1px 1px
              ${(props) => props.theme.customTheme.colors.primary},
            0 0 1px 2px rgba(255, 255, 255, 0.9) !important;
        }

        ${StyledBaseInput} {
          width: 55%;
          text-align: end;
          color: #151515;
          font-size: 24px;
          font-weight: 500;
          border: none;
          padding-right: 5px;
          &:focus {
          box-shadow: none;
        }
        }
        span {
          width: 45%;
        }
      }
    }
    &__actions {
      display: flex;
      width: 100%;
      gap: 10px;
    }
    &__btn {
      width: 100%;
      justify-content: center;
      font-size: 13px;
    }

    &__original-price {
      padding-top: 16px;
      border-radius: 10px;

      margin: 0;
      font-size: ${(props) => props.theme.customTheme.sizes.xMiddle};
      font-weight: 500;
      color: ${(props) => props.theme.customTheme.colors.primary};
      line-height: 1.5;
      text-align: center;
      background-color: #fff;
    }
  }
`;

export { StyledOffer };
